var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-left"},[_vm._t("footer-left")],2),_vm._v(" "),_c('div',{staticClass:"footer-center"},[_c('SlotMachineTicketContainer',{attrs:{"has-jackpot":_vm.hasJackpot}})],1),_vm._v(" "),_c('div',{staticClass:"footer-right"},[_vm._t("footer-right")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bccd5152","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlotMachine/SlotMachineBottom.vue
// module id = null
// module chunks = 